import React from "react";

export const PageNotFound = () => (<div><h1>Page not found!</h1></div>);
